/**
 * Sovereign Admin Copilot Floating Action Button (FAB)
 * EPIC-OPS-003 / STORY-OPS-003.3 (AC-3.2)
 */

import React from 'react';
import { useCopilot } from '../../context/CopilotContext';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import Tooltip from '@mui/material/Tooltip';

export const CopilotFab: React.FC = () => {
  const { isAuthorized, isOpen, openCopilot } = useCopilot();

  if (!isAuthorized || isOpen) {
    return null;
  }

  const isMac = typeof window !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
  const shortcutHint = isMac ? '⌘ + Shift + K' : 'Ctrl + Shift + K';

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Tooltip
        title={
          <div className="text-center py-1">
            <div className="font-semibold">Sovereign Copilot</div>
            <div className="text-xs text-emerald-300 font-mono mt-0.5">{shortcutHint}</div>
          </div>
        }
        arrow
        placement="left"
      >
        <button
          id="copilot-fab-button"
          onClick={openCopilot}
          aria-label="Open Sovereign Admin Copilot"
          className="flex items-center justify-center w-14 h-14 rounded-full bg-emerald-700 hover:bg-emerald-800 text-white shadow-xl hover:shadow-2xl transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-emerald-400 group border-2 border-emerald-500"
        >
          <SmartToyIcon className="w-7 h-7 text-white group-hover:rotate-6 transition-transform" />
          <span className="sr-only">Open Sovereign Admin Copilot</span>
        </button>
      </Tooltip>
    </div>
  );
};

export default CopilotFab;
